import React, { useState } from "react";
import { toast } from "react-toastify";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
	btnWrapper: {
		position: "relative",
	},
	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
}));

const IgnoreContactModal = ({ open, onClose, contactId, contactName, onConfirm }) => {
	const classes = useStyles();
	const [loading, setLoading] = useState(false);

	const handleIgnoreContact = async () => {
		setLoading(true);
		try {
			await api.put(`/contacts/${contactId}`, { isIgnored: true });
			toast.success("Contacto ignorado con éxito. No se recibirán nuevos tickets de este contacto.");
			if (onConfirm) {
				onConfirm();
			}
			onClose();
		} catch (err) {
			toastError(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
			<DialogTitle>¿Ignorar permanentemente a "{contactName}"?</DialogTitle>
			<DialogContent dividers>
				<Typography variant="body1" gutterBottom>
					El ticket individual ya ha sido ignorado.
				</Typography>
				<Typography variant="body1" gutterBottom>
					Ahora, tienes la opción de <strong>ignorar al contacto por completo</strong>.
				</Typography>
				<Typography variant="body2" color="textSecondary" paragraph style={{ marginTop: 16 }}>
					Si confirmas, <strong>todos los mensajes futuros</strong> de "{contactName}" serán bloqueados automáticamente. No crearán nuevos tickets ni recibirás notificaciones.
				</Typography>
				<Typography variant="body2" color="textSecondary">
					Podrás revertir esta acción más adelante desde la sección de "Contactos", editando el perfil de este usuario.
				</Typography>
			</DialogContent>
			<DialogActions>
        <Button
            onClick={() => onClose()}
            color="primary" 
            variant="outlined"
        >
            Cerrar
        </Button>

        <Button
            onClick={handleIgnoreContact}
            color="secondary"
            disabled={loading}
            variant="contained"
            className={classes.btnWrapper}
        >
            Ignorar Contacto
        </Button>
    </DialogActions>
		</Dialog>
	);
};

export default IgnoreContactModal;